import type { TAllowedStep } from '@besuites/auth/flow';
import type { TypeFlowAlternative, TypeFlowChoice } from '@/types/auth/types.auth.flow';

const OPTIONS: { choice: Exclude<TypeFlowChoice, null>; steps: string[]; label: string }[] = [
    { choice: 'passkey', steps: ['passkey.challenge', 'passkey.assert'], label: 'Usa una passkey' },
    { choice: 'password', steps: ['password.verify', 'password.set'], label: 'Usa la password' },
    { choice: 'totp', steps: ['totp.verify'], label: 'Usa l’app di autenticazione' },
    { choice: 'email-code', steps: ['email-otp.send'], label: 'Ricevi un codice via email' },
    { choice: 'recovery-code', steps: ['recovery-code.verify'], label: 'Usa un codice di recupero' },
];

export default function flowAlternativesOf(allowed: readonly TAllowedStep[], current: Exclude<TypeFlowChoice, null>, passkeySupported: boolean): TypeFlowAlternative[] {
    const steps = new Set(allowed.map((item) => item.step));
    return OPTIONS
        .filter((option) => option.choice !== current && option.steps.some((step) => steps.has(step)))
        .filter((option) => option.choice !== 'passkey' || passkeySupported)
        .map(({ choice, label }) => ({ choice, label }));
}
